import api from "../../../shared/api/apiClient";

export const crmSettingsApi = {
  async get() {
    const { data } = await api.get("/auth/crmSettings");
    return data;
  },

  async update(payload) {
    const { data } = await api.put("/auth/crmSettings", payload);
    return data;
  },

  async previewWorkSchedule(text) { const { data } = await api.post("/auth/crmSettings/work-schedule/preview", { text }); return data; },
  async importWorkSchedule(payload) { const { data } = await api.post("/auth/crmSettings/work-schedule/import", payload); return data; },
  async getWorkScheduleConfig() { const { data } = await api.get("/auth/crmSettings/work-schedule/config"); return data; },
  async getWorkScheduleSlots() { const { data } = await api.get("/auth/crmSettings/work-schedule/slots"); return data; },
  async addWorkScheduleSlot(payload) { const { data } = await api.post("/auth/crmSettings/work-schedule/slots", payload); return data; },
  async updateWorkScheduleSlot(id, payload) { const { data } = await api.put(`/auth/crmSettings/work-schedule/slots/${id}`, payload); return data; },
  async deleteWorkScheduleSlot(id) { const { data } = await api.delete(`/auth/crmSettings/work-schedule/slots/${id}`); return data; },
  async getWorkScheduleAvailability(params = {}) { const { data } = await api.get("/auth/crmSettings/work-schedule/availability", { params }); return data; },

  async uploadLogo(file) {
    const fd = new FormData();
    fd.append("logo", file);

    const { data } = await api.post("/auth/crmSettings/logo", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
  },

  async removeLogo() {
    const { data } = await api.delete("/auth/crmSettings/logo");
    return data;
  },

  async uploadFavicon(file) {
    const fd = new FormData();
    fd.append("favicon", file);

    const { data } = await api.post("/auth/crmSettings/favicon", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
  },

  async removeFavicon() {
    const { data } = await api.delete("/auth/crmSettings/favicon");
    return data;
  },

  async uploadStorefrontLogo(file) {
    const fd = new FormData();
    fd.append("logo", file);
    const { data } = await api.post("/auth/crmSettings/storefront/logo", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
  },

  async removeStorefrontLogo() {
    const { data } = await api.delete("/auth/crmSettings/storefront/logo");
    return data;
  },

  async uploadStorefrontFavicon(file) {
    const fd = new FormData();
    fd.append("favicon", file);
    const { data } = await api.post("/auth/crmSettings/storefront/favicon", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
  },

  async removeStorefrontFavicon() {
    const { data } = await api.delete("/auth/crmSettings/storefront/favicon");
    return data;
  },

  async getPublicBranding() {
    const { data } = await api.get("/public/crmBranding");
    return data;
  },



  // =========================
  // GOOGLE DRIVE STORAGE
  // =========================

  async getGoogleDriveStatus() {
    const { data } = await api.get("/auth/storage/google-drive/status");
    return data;
  },

  async getGoogleDriveAuthUrl() {
    const { data } = await api.post("/auth/storage/google-drive/auth-url");
    return data;
  },

  async disconnectGoogleDrive() {
    const { data } = await api.post("/auth/storage/google-drive/disconnect");
    return data;
  },

  async uploadStorageFile(file, params = {}, onProgress = null) {
    const fd = new FormData();
    fd.append("file", file);

    const { data } = await api.post("/auth/storage/files", fd, {
      params,
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: onProgress
        ? (event) => {
            const total = Number(event.total || 0);
            const loaded = Number(event.loaded || 0);
            const percent = total > 0 ? Math.min(100, Math.round((loaded * 100) / total)) : 0;
            onProgress(percent, event);
          }
        : undefined,
    });
    return data;
  },

  async listStorageFiles(params = {}) {
    const { data } = await api.get("/auth/storage/files", { params });
    return data;
  },

  async deleteStorageFile(attachmentId) {
    const { data } = await api.delete(`/auth/storage/files/${attachmentId}`);
    return data;
  },

  // =========================
  // TELEGRAM BOT
  // =========================

  async getTelegramSettings() {
    const { data } = await api.get("/auth/telegram/settings");
    return data;
  },

  async updateTelegramSettings(payload) {
    const { data } = await api.put("/auth/telegram/settings", payload);
    return data;
  },

  async setTelegramWebhook() {
    const { data } = await api.post("/auth/telegram/set-webhook");
    return data;
  },

  async deleteTelegramWebhook() {
    const { data } = await api.post("/auth/telegram/delete-webhook");
    return data;
  },

  async testTelegramBot(payload = {}) {
    const { data } = await api.post("/auth/telegram/test", payload);
    return data;
  },

  // =========================
  // RATE LIMITS
  // =========================

  async getRateLimitsConfig() {
    const { data } = await api.get("/api/system/rate-limits/config");
    return data;
  },

  async updateRateLimitsConfig(payload) {
    const { data } = await api.put("/api/system/rate-limits/config", payload);
    return data;
  },

  async toggleRateLimits(enabled) {
    const { data } = await api.post("/api/system/rate-limits/toggle", null, {
      params: { enabled },
    });
    return data;
  },

  async toggleAdminsManageRateLimits(allow) {
    const { data } = await api.post(
      "/api/system/rate-limits/permissions/allow-admins",
      null,
      {
        params: { allow },
      }
    );
    return data;
  },

  async getRateLimitsCurrent() {
    const { data } = await api.get("/api/system/rate-limits/current");
    return data;
  },

  async getRateLimitsUsageSummary(hours = 24) {
    const { data } = await api.get("/api/system/rate-limits/usage-summary", {
      params: { hours },
    });
    return data;
  },

  async resetRateLimitsToDefault() {
    const { data } = await api.post("/api/system/rate-limits/reset-to-default");
    return data;
  },

  async getTelegramSessionStats() {
    const { data } = await api.get("/auth/telegram/sessions/stats");
    return data;
  },

  async restartTelegramFlows() {
    const { data } = await api.post("/auth/telegram/sessions/restart-flows");
    return data;
  },

  async resetAllTelegramSessions() {
    const { data } = await api.post("/auth/telegram/sessions/reset-all");
    return data;
  },

  async resetOneTelegramSession(chatId) {
    const { data } = await api.post("/auth/telegram/sessions/reset-one", {
      chat_id: chatId,
    });
    return data;
  },

  async resetTelegramSessionsAndSendWelcome() {
    const { data } = await api.post("/auth/telegram/sessions/reset-and-welcome");
    return data;
  },
};
